@if (visible()) {
<div
  class="fab-container"
  [style.left.px]="fabPos().x"
  [style.top.px]="fabPos().y"
>

  <!-- 半透明遮罩：点击空白区域收起 -->
  @if (fabOpen() || activeDialog()) {
    <div class="fab-backdrop" (click)="onBackdropClick($event)"></div>
  }

  <!-- 打开的功能对话框 -->
  @if (activeDialog()) {
    <div class="fab-dialog" (click)="$event.stopPropagation()">
      <app-chat-dialog
        [initialMode]="activeDialog()!"
        (closeRequest)="closeDialog()"
      />
    </div>
  }

  <!-- FAB 主按钮 + Speed Dial 菜单 -->
  <div class="fab-wrap" (click)="$event.stopPropagation()">
    @if (fabOpen()) {
      <div class="fab-menu">
        @for (action of visibleActions(); track action.id) {
          <div class="fab-action-row">
            <button
              class="fab-action"
              (click)="onActionClick(action, $event)"
              [attr.aria-label]="actionLabel(action)"
            >
              <span class="fab-action__icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <path [attr.d]="action.icon"/>
                </svg>
              </span>
              <span class="fab-action__label">
                <span class="fab-action__text">{{ actionLabel(action) }}</span>
                <span class="fab-action__desc">{{ actionDesc(action) }}</span>
              </span>
            </button>

            <!-- 创建差异报告下的 OTI / LP 快捷入口 -->
            @if (action.id === 'voice-report' && canQuickReport()) {
              <div class="fab-report-types">
                <button
                  class="fab-report-type fab-report-type--oti"
                  (click)="openReportType('OTI', $event)"
                  [title]="'floatingBall.otiTitle' | translate"
                >OTI</button>
                <button
                  class="fab-report-type fab-report-type--lp"
                  (click)="openReportType('LP', $event)"
                  [title]="'floatingBall.lpTitle' | translate"
                >LP</button>
              </div>
            }
          </div>
        }
      </div>
    }

    <!-- 主按钮（支持拖动，避免遮挡发送按钮等） -->
    <button
      class="fab-main"
      [class.fab-main--open]="fabOpen()"
      [class.fab-main--dragging]="!!dragStart"
      (pointerdown)="onFabPointerDown($event)"
      (pointermove)="onFabPointerMove($event)"
      (pointerup)="onFabPointerUp($event)"
      (click)="onFabClick()"
      [attr.aria-label]="fabOpen() ? ('floatingBall.collapseAssistant' | translate) : ('floatingBall.openAssistant' | translate)"
    >
      @if (isInitializing()) {
        <div class="fab-main__spinner"></div>
      } @else {
        <tds-icon
          [name]="fabOpen() ? 'cross' : 'mic'"
          size="26"
          [class.fab-main__icon--rotate]="fabOpen()"
        ></tds-icon>
      }
    </button>
  </div>
</div>
}
